<template>
  <div dir="ltr" class="is-flex is-align-items-center is-flex-wrap-wrap page_title" :class="{'fixed-width': pageTitleAdditions.company_self_row}">
    <p><b>{{ title }}</b></p>
    <div class="horizontal_space"></div>
    <div v-if="link_entity_payload" class="is-flex is-align-items-center is-flex-wrap-wrap">
      <div v-if="title">
        <p>-</p>
        <div class="horizontal_space"></div>
      </div>
      <p>{{ link_entity_payload.resource_type }}:</p>
      <div class="horizontal_space"></div>
      <link-entity :payload="link_entity_payload"></link-entity>
    </div>
    <div class="horizontal_space"></div>
    <div v-if="link_entity_payload" class="is-flex is-align-items-center is-flex-wrap-wrap">
      <div class="is-flex is-align-items-center">
        <p>({{ link_entity_payload.resource_type && link_entity_payload.resource_type.toUpperCase() + " ID: " + link_entity_payload.resource_id}})<span v-if="pageTitleAdditions.showWhatsApp">,</span></p>
        <WhatsAppLink v-if="pageTitleAdditions.showWhatsApp" :phoneNumber="link_entity_payload.phone_number" :message="offers_helper.outSourceTemplate(whatsappParams, whatsappTemplate)" class="mx-3"></WhatsAppLink>
        <p>,<span class="has-text-danger">{{ priorityWarning }}</span></p>
      </div>
    </div>
    <div v-if="pageTitleAdditions.company_self_row" class="break"></div>
    <div v-else class="horizontal_space"></div>
    <div v-if="link_entity_payload && link_entity_payload.resource_type == 'Position'" class="is-flex is-align-items-center is-flex-wrap-wrap mb-5">
      <p>Company:</p>
      <div class="horizontal_space"></div>
      <link-entity :payload="link_entity_payload.company"></link-entity>
      <div class="horizontal_space"></div>
      <p>(COMPANY ID: {{link_entity_payload.company.resource_id}})</p>
      <p class="has-text-danger">{{ link_entity_payload.priority_warning }}</p>
      <div class="m-4 is-size-6" v-if="pageTitleAdditions.showGhanaFlag">
        <GhanaFlag :payload="link_entity_payload" :eager_load="true" :short_version="true" :sent_applicants="pageTitleAdditions.sent_applicants" />
      </div>
    </div>
  </div>
</template>
<script>
import LinkEntity from '@/components/LinkEntity'
import GhanaFlag from '@/components/GhanaFlag'
import WhatsAppLink from '@/components/WhatsAppLink'
import OffersHelper from '@/custom/classes/offers_helper'
import { getOwner } from '@/custom/classes/my_utils.js'
export default {
  name: 'page-title',
  props: {
    override_data: {
      type: Object
    },
    title: {
      type: String
    },
    additionData: {
      type: Object
    },
    pageTitleAdditions: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      offers_helper: new OffersHelper(),
      link_entity_payload: undefined
    }
  },
  created () {
    if (this.getResourceType() == '') {
      this.setTitle(this.title)
      return
    }
    this.getLinkEntityPayload()
  },
  computed: {
    priorityWarning () {
      return this.additionData && this.additionData.priority_warning
    },
    whatsappTemplate () {
      const env = this.$settings.get({ path: 'operation_name' })
      switch (env) {
        case 'Rebase':
          return 'rebaseVettingMessage'
        case 'Piola':
          return 'piolaVettingMessage'
        case 'Suitup':
        default:
          return 'suitupVettingMessage'
      }
    },
    whatsappParams () {
      return { admin: getOwner().name, applicant: this.link_entity_payload.first_name }
    }
  },
  methods: {
    getLinkEntityPayload () {
      let resource_type = this.getResourceType()
      if (resource_type == 'Applicant') {
        this.getApplicantTitle()
      }
      if (resource_type == 'Company') {
        this.getCompanyTitle()
      }
      if (resource_type == 'Position') {
        this.getPositionTitle()
      }
    },
    getResourceId () {
      if (this.override_data != undefined) {
        return this.override_data.resource_id
      }
      let id_string = this.getResourceType().toLowerCase() + '_id'
      return this.$route.query[id_string]
    },
    getCompanyId () {
      return this.override_data != undefined ? this.override_data.company_id : this.$route.query.company_id
    },
    getResourceType () {
      if (this.override_data != undefined) {
        return this.override_data.resource_type
      }
      if (this.$route.query.applicant_id) {
        return 'Applicant'
      }
      if (this.$route.query.position_id) {
        return 'Position'
      }
      if (this.$route.query.company_id) {
        return 'Company'
      }
      return ''
    },
    getApplicantTitle () {
      this.$network_utils.getApplicant({ id: this.getResourceId() }).then(response => {
        this.link_entity_payload = response
        let title = this.title + ' - ' + response.first_name + ' ' + response.last_name
        this.setTitle(title)
      })
    },
    getCompanyTitle () {
      this.$network_utils.getCompany({ id: this.getResourceId() }).then(response => {
        this.link_entity_payload = response
        let title = this.title + ' - ' + response.name
        this.setTitle(title)
      })
    },
    getPositionTitle () {
      let requests = [this.$network_utils.getPosition({ id: this.getResourceId() }), this.$network_utils.getCompany({ id: this.getCompanyId() })]
      this.$network_utils.caller.axios.all(requests).then(response => {
        let position_data = response[0]
        let company_data = response[1]
        this.link_entity_payload = position_data
        this.link_entity_payload.resource_type = 'Position'
        this.link_entity_payload.resource_id = position_data.id
        this.link_entity_payload.company = company_data
        let title = this.title + ' - ' + position_data.title
        this.setTitle(title)
      })
    },
    setTitle (title) {
      if (this.override_data) {
        return
      }
      document.title = title
    }
  },
  components: {
    LinkEntity,
    GhanaFlag,
    WhatsAppLink
  }
}
</script>
<style scoped>
  .page_title{
    font-size: 25px;
  }
  .break {
    flex-basis: 100%;
    height: 0;
  }
  .fixed-width {
    min-height: 220px;
  }
</style>
